import Vue from 'vue'
import VueRouter from 'vue-router'

import home from './home'
import login from './login'

import institutionList from '@/router/institution/institutionList'
import institutionAdd from '@/router/institution/institutionAdd'

Vue.use(VueRouter)

const routes = [
    home,
    login,
    institutionList,
    institutionAdd
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
